/**
 * The two HUD layouts from mockup 06, picked in the ⚙ settings panel and kept
 * per browser. Edges (A): a full-width top bar, the Empire drawer open, the
 * hovered tile's card above the minimap. Contextual (B): a compact top-centre
 * pill with players and ⚙ top right, the Empire drawer closed until E, and
 * the hovered tile as a tooltip at the cursor.
 */
export type HudMode = 'edges' | 'contextual';

export const HUD_MODES: ReadonlyArray<{ mode: HudMode; label: string; title: string }> = [
  {
    mode: 'edges',
    label: 'Edges',
    title: 'One top bar, the Empire list open at the left, tile info above the minimap',
  },
  {
    mode: 'contextual',
    label: 'Contextual',
    title: 'A small top pill, the Empire list behind E, tile info at the cursor: the most map',
  },
];

export function isHudMode(value: unknown): value is HudMode {
  return value === 'edges' || value === 'contextual';
}
